/**
 * The formatters-custom file is a place to define custom formatters or to
 * override any of the baked-in formatters like phone number formatting.
 *
 * e.g. You may write something like below
 * export function address(profile) {
 *   return `111 Yext Street`;
 * }
 */
import escape from 'escape-html';

export function highlightFieldNew(fieldValue, matchedSubstrings = []) {
  let highlightedString = '';

  // We must first sort the matchedSubstrings by ascending offset. 
  const sortedMatches = matchedSubstrings.slice()
    .sort((match1, match2) => match1.offset - match2.offset);
  
  let processedFieldValueIndex = 0;
  sortedMatches.forEach(match => {
    const { offset, length } = match;
    highlightedString += escape(fieldValue.substring(processedFieldValueIndex, offset))
      + `${escape(fieldValue.substring(offset, offset + length))}`;
    processedFieldValueIndex = offset + length;
  });
  highlightedString += escape(fieldValue.substring(processedFieldValueIndex));
  return highlightedString;
}

//parse the html string and highlight the matchings
function highlightSubstrings(htmlString, substrings) {
  if (!htmlString || !substrings || substrings.length === 0) {
    return htmlString || '';
  }

  const container = document.createElement('div');
  container.innerHTML = htmlString;
  const uniqueSubstrings = [...new Set(substrings)];

  // Highlight function for text nodes
  function highlightNode(node) {
    const regex = new RegExp(`(${uniqueSubstrings.join('|')})`, 'gi');
    const fragments = node.textContent.split(regex);

    const fragmentNodes = fragments.map((fragment) => {
      if (uniqueSubstrings.some((sub) => sub.toLowerCase() === fragment.toLowerCase())) {
        const span = document.createElement('span');
        span.className = 'highlight';
        span.textContent = fragment;
        return span;
      }
      return document.createTextNode(fragment);
    });

    // Replace the original node with the fragments
    fragmentNodes.forEach((fragmentNode) => node.parentNode.insertBefore(fragmentNode, node));
    node.remove();
  }

  // Recursively process all nodes in the container
  function processNode(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      highlightNode(node);
    } else if (node.nodeType === Node.ELEMENT_NODE && node.childNodes.length > 0) {
      node.childNodes.forEach(processNode);
    }
  }

  Array.from(container.childNodes).forEach(processNode);
  return container.innerHTML;
}

// extract matching of a highlighted field
function extractMatchings(s_snippet, matchedSubstrings) {

  return matchedSubstrings.map(({ offset, length }) =>
    s_snippet.slice(offset, offset + length)
  );
}

export const highlightTitleFieldNW = (profile) => {
  if (!profile) return '';

  const isNationWideSiteSearchExp =
    ANSWERS?.core?._experienceKey === 'nationwide-site-search';

  let title = profile.name;

  if(isNationWideSiteSearchExp) {
    if (profile.d_highlightedFields && profile.d_highlightedFields.name) {
      const snippet = profile.d_highlightedFields.name.value;
      const matchings = extractMatchings(snippet, profile.d_highlightedFields.name.matchedSubstrings);
      title = highlightSubstrings(title, matchings);
    }
  }

  return title;
}

export const highlightDetailsFieldNW = (profile, description) => { 
  if (!profile || !description) return description;

  const isNationWideSiteSearchExp =
    ANSWERS?.core?._experienceKey === 'nationwide-site-search';

  let details = description;

  if (isNationWideSiteSearchExp) {
    if (profile.d_highlightedFields && profile.d_highlightedFields.s_snippet) {
      const answer = details;
      const highlightedSnippet = profile.d_highlightedFields.s_snippet.value;
      const matchings = extractMatchings(highlightedSnippet, profile.d_highlightedFields.s_snippet.matchedSubstrings);
      details = highlightSubstrings(answer, matchings);
    }
  }

  return details;
}